import { useEffect, useState } from "react";
import { fetchItemGroups, downloadItemGroupsExcel } from "../Api/ViewItemGroups";
import { Container, Table, Button } from "react-bootstrap";

import { toast } from "react-toastify";
import moment from "moment";

const ViewItemGroups = () => {
  const [itemGroups, setItemGroups] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    const loadItemGroups = async () => {
      try {
        const data = await fetchItemGroups();
        setItemGroups(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Item Groups`);
      }
    };

    loadItemGroups();
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadItemGroupsExcel();
      
      if (!response.data) {
        throw new Error("No data received from server");
      }
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'ItemGroups_Data.xlsx');
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      }, 100);
      
      toast.success("Item Groups data download started!");
    } catch (error) {
      console.error("Download error:", error);
      toast.error(`🦄 Download failed: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      
        <div>
          <Container className="list-container">
           <div className="header-background">
              <h2 className="header-list-title">View Item Groups</h2>
              <Button className="gradient-btn"
                variant="primary" 
                onClick={handleDownload}
                disabled={isDownloading || itemGroups.length === 0}
              >
                {isDownloading ? 'Downloading...' : 'Download Data'}
              </Button>
            </div>

            {itemGroups.length > 0 ? (
              <Table bordered hover responsive className="data-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Code</th>
                    <th>Description</th>
                    <th>Item Type</th>
                    <th>Created On</th>
                    <th>Created By</th>
                    <th>Changed On</th>
                    <th>Changed By</th>
                  </tr>
                </thead>
                <tbody>
                  {itemGroups.map((itemGroup, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{itemGroup.code}</td>
                      <td>{itemGroup.description}</td>
                      <td>{itemGroup.itemType}</td>
                      <td>
                        {moment(itemGroup.createdOnDate).format('L')} at {itemGroup.createdOnTime?.substring(0, 8)}
                      </td>
                      <td>{itemGroup.createdBy}</td>
                      <td>
                        {itemGroup.changedOnDate ? 
                          `${moment(itemGroup.changedOnDate).format('L')} at ${itemGroup.changedOnTime?.substring(0, 8)}` : 
                          'N/A'}
                      </td>
                      <td>{itemGroup.changedBy || 'N/A'}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <p className="no-data">No item groups found.</p>
            )}
          </Container>
        </div>
      
    </>
  );
};

export default ViewItemGroups;